export const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyDdw1xU__Db-NwQ8H_NN9Fove0NZJo7Aps',
  authDomain: 'conveyour---dev.firebaseapp.com',
  projectId: 'conveyour---dev',
  storageBucket: 'conveyour---dev.appspot.com',
  messagingSenderId: '389375277233',
  appId: '1:389375277233:web:ef25f1a3bbc3f22841ca90',
  measurementId: 'G-Y6JS47VJ9J',
};
